'use strict';

var assign = require(339);

var BpmnModdle = require(52);

var packages = {
  bpmn: require(69),
  bpmndi: require(70),
  dc: require(71),
  di: require(72)
};

module.exports = function(additionalPackages, options) {
  return new BpmnModdle(assign({}, packages, additionalPackages), options);
};